export default "__VITE_ASSET__20e41ccb__"